import React from 'react'
import { connect } from 'react-redux';
import Endereco from './Endereco';
import selecionarEndereco from '../../actions/endereco/selecionarEndereco';
import ModalCadastroEnderecoPessoa from './ModalCadastroEnderecoPessoa';
import AtualizarCadastroPessoa from './AtualizarCadastroPessoa';

export class Pessoa extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      botaoEditarHabilitado: false
    }
  }

  campoDesabilitado(label, valor) {
    return (<div className='col-md-4'>
      <div>
        <label className='mt-2'>{label}:</label>
        <div>
          <input className='form-control'
            value={valor}
            disabled={true} />
        </div>
      </div>
    </div>)
  }

  exibirEnderecos() {
    if (this.props.pessoa.enderecos) {
      return (
        <div className="container-fluid">
          <div className="row">
            {this.props.pessoa.enderecos.map(endereco => <Endereco key={endereco.id}
              endereco={endereco}
              selecionarEndereco={this.props.selecionarEnderecoRemetenteDestinatario}
              enderecoSelecionado={this.props.enderecoSelecionado} />)}
          </div>
        </div>
      )
    }
  }

  limparFormularioEndereco() {
    this.props.selecionarEndereco({})
  }

  exibirBotaoNovoEndereco() {
    return (<div className="row mb-2">
      <div className="col-md-12">
        <div className="text-right">
          <button data-toggle="modal" data-target="#modalCadastrarEnderecoPessoa" className='btn btn-sm btn-laranja'
            onClick={this.limparFormularioEndereco.bind(this)}>
            Novo Endereço
          </button>
        </div>
      </div>
    </div>)
  }

  preencherFormAtualizarCadastroPessoa() {
    this.props.changeFieldValue('formularioAtualizarCadastroPessoa', 'nome', this.props.pessoa.nome);
    this.props.changeFieldValue('formularioAtualizarCadastroPessoa', 'email', this.props.pessoa.email);
    this.props.changeFieldValue('formularioAtualizarCadastroPessoa', 'telefone', this.props.pessoa.telefone);
  }

  habilitarDesabilitarBotao(valor) {
    this.setState({
      botaoEditarHabilitado: valor
    })
  }

  exibeBotaoEditar() {
    return (
      <>
        <button type="button" className="btn btn-excluir"
          style={{ color: 'red' }}
          onClick={() => this.habilitarDesabilitarBotao(true)}>
          <span>Editar</span>
        </button>
      </>
    )
  }

  render() {
    return (
      <React.Fragment>
        <div className='col-md-12'>
          {!this.state.botaoEditarHabilitado ? <div>
            <div className='row'>
              {this.campoDesabilitado('Nome', this.props.pessoa.nome)}
              {this.campoDesabilitado('E-mail', this.props.pessoa.email)}
              {this.campoDesabilitado('Telefone', this.props.pessoa.telefone)}
            </div>
            {this.exibeBotaoEditar()}
          </div>
            : <>
              {this.preencherFormAtualizarCadastroPessoa()}
              <AtualizarCadastroPessoa pessoa={this.props.pessoa}
                buscarPessoa={this.props.buscarPessoa}
                habilitarDesabilitarBotao={this.habilitarDesabilitarBotao.bind(this)} />
            </>}
          <div className='row text-center'>
            <div className="col-12 titulo-principal">
              <h3 id="titulo-page" className='text-center' style={{ textDecoration: 'underline' }}>Selecione um Endereço</h3>
              {this.exibirBotaoNovoEndereco()}
              {this.exibirEnderecos()}
            </div>
          </div>
        </div>
        <ModalCadastroEnderecoPessoa pessoa={this.props.pessoa} buscarPessoa={this.props.buscarPessoa} />
      </React.Fragment>
    )
  }
}

export default connect(null, { selecionarEndereco })(Pessoa);
